// @flow
// amd version: js-amd/src/common/PageDwell.js

import { useState, useEffect } from 'react';
import Logging from '@ta/common.logging';
import trackEventAJAX from '@ta/common.tracking';
import useInterval from './timer';
import usePageVisibility from './visibility';

const MILESTONES = [
  1000,
  3000,
  8000,
  18000,
  33000,
  63000,
  108000,
  168000,
  243000,
  333000,
  438000,
  558000,
  708000,
  888000,
  1188000,
  1788000,
  2688000,
];

/**
 * Tracks a GARecord event
 * @param action
 * @param context
 * @param value
 */
function trackGARecordEvnt(action: string, context: string = '', value: number = 0) {
  trackEventAJAX({
    module: 'VWBLTY',
    action,
    context,
    nonInteractive: false,
    value,
  });
}

/** A component monitoring page visibility and send GARecord periodically */
export default function PageDwell(trackingLabel: string, isDebug: boolean = false) {
  const [count, setCount] = useState(0);
  const [delay, setDelay] = useState(1000);
  const [isRunning, setIsRunning] = useState(true);
  const [mileStoneIndex, setMilestoneIndex] = useState(0);

  let visibility;
  usePageVisibility(v => {
    visibility = v;
  });
  useInterval(
    () => {
      if (visibility === 'visible') {
        setCount(count + delay);
      }
    },
    isRunning ? delay : null,
  );

  useEffect(() => {
    if (mileStoneIndex < MILESTONES.length && count > MILESTONES[mileStoneIndex]) {
      if (isDebug) {
        Logging.debug(
          `${trackingLabel} reached a milestone of ${MILESTONES[mileStoneIndex] /
            1000} seconds in view`,
        );
      }
      trackGARecordEvnt(`in_view_${MILESTONES[mileStoneIndex] / 1000}s`, `${trackingLabel}`);
      setMilestoneIndex(mileStoneIndex + 1);
      setDelay(2000); // <-- maybe can do something smarter to avoid checking too frequently
    }
    const stillTracking = count <= MILESTONES[MILESTONES.length - 1] && visibility === 'visible';
    if (isDebug) {
      Logging.debug(stillTracking ? 'tracking is running' : 'tracking is stopped');
    }
    setIsRunning(stillTracking);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count, visibility]);

  return null;
}
